import { useGetCardDetail } from '@/queries/card';
import { useFlag } from '@/unleash';

export const useIsMofidCardDisabled = () => {
  const { data } = useGetCardDetail();
  const { isEnabled } = useFlag('web.card.checkMofidCardAccessibility');
  const inaccessibleStatuses = ['UnableToIssue', 'UserNotVerified'];

  const isMofidCardDisabled = data?.status
    ? inaccessibleStatuses.includes(data?.status)
    : false;
  return {
    isMofidCardDisabled: isEnabled && isMofidCardDisabled,
  };
};
